import { PostHog as PosthogClientSide } from 'posthog-js'

class PostHogManager {
  private posthogClientSide: PosthogClientSide | null = null
  private initialized = false
  private pendingCaptures: ((client: PosthogClientSide) => void)[] = []

  captureWhenReady(capture: (client: PosthogClientSide) => void) {
    if (this.posthogClientSide?.__loaded) capture(this.posthogClientSide)
    else if (this.pendingCaptures.length < 100)
      this.pendingCaptures.push(capture)
  }

  initialize(posthog: PosthogClientSide) {
    this.posthogClientSide = posthog
    this.initialized = true
    if (!posthog.__loaded) return
    const pending = this.pendingCaptures
    this.pendingCaptures = []
    for (const capture of pending) {
      try {
        capture(posthog)
      } catch {
        /* Optional analytics cannot block startup. */
      }
    }
  }

  isInitialized() {
    return this.initialized && this.posthogClientSide !== null
  }

  getClientInstance() {
    return this.posthogClientSide
  }
}

export const posthogManager = new PostHogManager()
